import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface InitStata {
  selectedTargetFranchisee: any;
}

const initialState: InitStata = {
  // 用到的字段：name（加盟商姓名）、id: （加盟商id）,uniqueId: （加盟商唯一标识的值）uniqueName: （加盟商唯一标识的中文名）
  selectedTargetFranchisee: null, // 选择的加盟商
};

const customerSlice = createSlice({
  name: 'standardstore',
  initialState,
  reducers: {
    selectedFranchisee: (state = initialState, action: PayloadAction<any>) => {
      state.selectedTargetFranchisee = action.payload;
    },
  },
});

// 导出action
export const { selectedFranchisee } = customerSlice.actions;

export default customerSlice.reducer;
